import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incomplete-registration-block',
  templateUrl: './incomplete-registration-block.component.html',
  styleUrls: ['./incomplete-registration-block.component.less']
})
export class IncompleteRegistrationBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
